import { render, staticRenderFns } from "./Verify2FA.vue?vue&type=template&id=1199e2c5"
import script from "./Verify2FA.vue?vue&type=script&lang=js"
export * from "./Verify2FA.vue?vue&type=script&lang=js"
import style0 from "./Verify2FA.vue?vue&type=style&index=0&id=1199e2c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports